import { render } from "./GlobalFooter.vue?vue&type=template&id=49cc2d30&scoped=true"
import script from "./GlobalFooter.vue?vue&type=script&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&lang=js"

import "./GlobalFooter.vue?vue&type=style&index=0&id=49cc2d30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cc2d30"]])

export default __exports__